<template>
  <div>
    <el-form-item label="提示文字">
      <el-input size="small" v-model="value.placeholder" placeholder="请设置提示语" />
    </el-form-item>
    <el-form-item label="选项设置" v-show="false">
      <el-cascader :options="selectList" @change="handleChange" v-model="notset"
        placeholder="未设置" size="mini"  :show-all-levels="false">
      </el-cascader>
    </el-form-item>
    <el-form-item label="报告类目">
      <el-select v-model="value.report" placeholder="未选择" size="mini" multiple>
        <el-option v-for="item in value.options" :value="item.id" :label="item.name" :key="item.id"></el-option>
      </el-select>
    </el-form-item>

  </div>
</template>

<script>
import { getReportType } from '@/api/ops/report';

export default {
  name: "ReportTypeInputConfig",
  props: {
    value: {
      type: Object,
      default: () => {
        return {}
      }
    }
  },
  data() {
    return {
      opts: [],
      notset: '',
      selectList: [
        {
          value: '2',
          label: '系统数据',
          children: [{
            value: '3',
            label: '档案',
            children: [
              {
                value: '8',
                label: '报表类目'
              }
          ]},
        ]
        }
      ],
      dragOption: {
        animation: 300,
        sort: true
      }
    }
  },
  created() {
    this.notset = ['2', '3', '8']
    this.handleChange(this.notset)
  },
  methods: {
    handleChange(e) {
      this.value.options = []
      if(this.value.opts) this.value.opts = e
      if (e[e.length - 1] == '8') {
        getReportType().then(res => {
          this.value.options = res.data;
        });
      } 
    }
  }
};
</script>

<style scoped>
::v-deep .options {
  .el-form-item__label {
    display: block;
    width: 100%;
    text-align: left;
  }

  .el-icon-rank {
    padding-right: 5px;
    cursor: move;
  }

  .option-item {
    .el-input {
      width: 250px;
      float: right;
    }
  }
}

.option-item-label {
  height: 30px;
  line-height: 30px;

  button {
    float: right;
  }
}

</style>
